import { MobileLayout } from "./mobile-layout"

interface LegalLayoutProps {
  title: string
  lastUpdated?: string
  children: React.ReactNode
}

export function LegalLayout({ title, lastUpdated, children }: LegalLayoutProps) {
  return (
    <div className="min-h-[100dvh] bg-background pb-12">
      <MobileLayout className="pt-6">
        <button
          type="button"
          onClick={() => window.history.back()}
          className="mb-4 flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
        >
          <svg width="6" height="10" viewBox="0 0 6 10" fill="none">
            <path
              d="M5 1L1 5L5 9"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Back
        </button>

        <h1 className="text-2xl font-bold">{title}</h1>
        {lastUpdated && (
          <p className="mt-1 text-xs text-muted-foreground">Last updated: {lastUpdated}</p>
        )}

        <div className="mt-6 space-y-6 text-sm leading-relaxed text-foreground/80 [&_h2]:mt-8 [&_h2]:text-base [&_h2]:font-semibold [&_h2]:text-foreground [&_p]:mt-2 [&_ul]:mt-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1">
          {children}
        </div>
      </MobileLayout>
    </div>
  )
}
